import React from "react";

const AppLink = ( props ) =>
{

    const height = props.height === undefined || props.height === null ? '60px' : props.height;

    const width = props.width === undefined || props.width === null ? '60px' : props.width;

    return (
        <div className='icon-content'>
            <div className='selection-layout'>
                <a href={props.link} target={props.target}>{props.title}
                    <div>
                        <img alt='image' height={height} width={width} src={props.imageSrc} style={{alignSelf: "center"}}/>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default AppLink ;